<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
/**
 * 不推荐 在APP.vue上做 部分页面的逻辑操作 与 页面 部分组件显示隐藏判断
 * 有需要 自定义部分页面共用置顶导航栏 或 底部导航栏时 在 AppMain组件上进行编写
 * 或者有需要 缓存的页面  可用 AppMain组件
 *
 *
 * 主题样式 (vant) 在 assets/style/theme.less
 * 主题色 品牌色 主题字体样式 在 assets/style/theme.less @theme-color: #fff; @brand-color: #fff;
 * 建议 字体规格 有阶梯式的统一 正文 标题 子标题 副标题 有样式上的统一 至少颜色上有统一
 * 建议 主要颜色  警告颜色 通过颜色  默认颜色 危险颜色 也有 统一
 * 规范化 有利于 多人开发 以及日后客户变更主题样式 以及 迭代需求 主题切换
 */
export default {
  name: "App",
};
</script>
<style lang="less">
#app {

  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: @theme-color;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}

html,
body {
  // overflow-y: hidden;
  // overflow-x: hidden;
  background-color: @theme-color;
  padding: 0;
  width: 100%;
  scroll-behavior: smooth;
}

.ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
.ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
.ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #ffedee !important;
}
</style>
